import { FC } from 'react';
import { Button, Divider, Flex } from 'antd';
import { useTranslation } from 'react-i18next';
import { LinkIcon } from '@/components';
import {
  // footer1, footer2,
  footer3,
  //   footer4,
  rednote
} from '@/assets';
import styles from './footer.module.css';
const Footer: FC = () => {
  const { t } = useTranslation();
  const footerLinkList = [
    // {
    //   icon: footer1,
    //   url: ''
    // },
    // {
    //   icon: footer2,
    //   url: ''
    // },
    {
      icon: footer3,
      url: 'https://www.instagram.com/iseshimajourney'
    },
    {
      icon: rednote,
      url: 'https://xhslink.com/m/6tI4p9L4kBD'
    }
  ];
  return (
    <footer className={styles.footer}>
      <Flex
        justify="center"
        align="center"
        vertical
        className={styles.footerContent}
      >
        <Flex gap={16} justify="center" align="center">
          {footerLinkList.map((item, index) => (
            <div className={styles.footerLink} key={index}>
              <LinkIcon
                iconUrl={item.icon}
                iconHeight={18}
                iconWidth={18}
                onClick={() => {
                  window.open(item.url, '_blank');
                }}
              ></LinkIcon>
            </div>
          ))}
        </Flex>
        <div>
          <Flex gap={28} wrap justify="center" align="center">
            <Button color="default" variant="link" size="small">
              {t('footer.termsOfService')}
            </Button>

            <Button color="default" variant="link" size="small">
              {t('footer.privacyPolicy')}
            </Button>
            <Button color="default" variant="link" size="small">
              {t('footer.specifiedCommercialTransactions')}
            </Button>
            <Button color="default" variant="link" size="small">
              {t('footer.contact')}
            </Button>
          </Flex>
        </div>
        <Divider className={styles.divider}></Divider>
        <section className={styles.adress}>{t('footer.address')}</section>
        <section className={styles.copyright}>{t('footer.copyright')}</section>
      </Flex>
    </footer>
  );
};

export default Footer;
